import { render, staticRenderFns } from "./translation-fields.vue?vue&type=template&id=3795341c&scoped=true"
import script from "./translation-fields.vue?vue&type=script&lang=js"
export * from "./translation-fields.vue?vue&type=script&lang=js"
import style0 from "./translation-fields.vue?vue&type=style&index=0&id=3795341c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3795341c",
  null
  
)

export default component.exports